import { Component, Inject, Input } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-biz-name-card',
  templateUrl: './biz-name-card.component.html',
  styleUrl: './biz-name-card.component.scss'
})
export class BizNameCardComponent {

  constructor(
    @Inject('WINDOW') public window
  ){

  }
  @Input({
    required: true
  })
  bizCard: any;

  elementType: 'url';

  imgUrl =  environment.ImageUrl;

}
